import { styled, Table, Panel } from 'react-ui-kit-exante';

export const StyledPermissionsTablePanel = styled(Panel)`
  height: 100%;
`;

export const StyledPermissionsTable = styled(Table)`
  margin: 8px -24px;
`;
